import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedDroitApiService } from './droit-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class DroitApiService extends GeneratedDroitApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
